// extracted by mini-css-extract-plugin
export default {"removedParentIssuesList":"ParentIssueRemovedEvent-module__removedParentIssuesList--r23Sc","removedParentIssueItem":"ParentIssueRemovedEvent-module__removedParentIssueItem--dORNe"};